<template>
    <div>
        <div style="height: 2000px">首页</div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>
